export default {
  lang: "2",
  uid: "",
  tabs: "",
  GMCUID: "", // sku 父表格UID
  FUNAPI: "",
  ISVALIDATE: "0",
  userUid: localStorage.getItem("userUid") || "",
  isGrCombine: "false",
  pbLoading: false,
  Role: "", // d当前用户角色
  partStatus: "", // 父表选中的当前状态
  tabsTitle: "", // 父表选中的当前title
  iskeepLive: true, // top点击缓存 left 请求数据
  whsCode: '', // 当前warhouseCode menu 接口返回
  scanpackWay: null, // scanpack  系统参数
  tmsDrag: {}, // tms 拖拽参数
  tms: {
    useCase1: {},
    useCase2: {},
    useCase3: {},
    useCase4: {},
  },
  systemParam : {},
  projectCode:"",
  SF_SCPPrint: null
};
